var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "scrollPane",
    { staticStyle: { height: "410px" } },
    [
      _vm._l(_vm.visionTask, function (item) {
        return [
          _c("listItem", {
            key: item.id,
            ref: "listItem",
            refInFor: true,
            attrs: { info: item, progress: item.progress },
            on: {
              handleClickAgain: function ($event) {
                return _vm.handleClickAgain(item)
              },
              fairing: function ($event) {
                return _vm.onhandleFairing(item)
              },
              handleClickPause: function ($event) {
                return _vm.handleClickPause(item)
              },
              handleClickReload: function ($event) {
                return _vm.handleClickReload(item)
              },
            },
          }),
        ]
      }),
      !_vm.visionTask.length
        ? _c("div", { staticClass: "task-no-data" }, [
            _c("div", { staticClass: "task-no-data-icon-box" }, [
              _c("img", {
                staticClass: "task-no-data-icon",
                attrs: { src: require("@/icons/svg/t_nodata.svg"), alt: "" },
              }),
            ]),
            _c("div", [_vm._v("暂无内容")]),
          ])
        : _vm._e(),
      _vm.fairingStatus
        ? _c("div", {
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }